
import React from 'react';

import {
    FaArrowCircleLeftIcon,
    FaArrowCircleRightIcon,
    Container,
    PaginationBox,
    PaginationButton
} from './styles';

interface IPaginationProps {
    page: IsseusPage;
    onChange: Function;
}

interface IsseusPage {
    last: boolean;
    totalPages: number;
    number: number;
    first: boolean;
}

const Pagination : React.FC<IPaginationProps> = ({ page, onChange }: IPaginationProps) =>  {

    return (
        <Container>
            <PaginationBox>
                <PaginationButton
                    disabled={page.first}
                    onClick={() => onChange(page.number - 1)} >
                    <FaArrowCircleLeftIcon />
                </PaginationButton>
                <p>{`${page.number + 1} de ${page.totalPages}`}</p>
                <PaginationButton
                    disabled={page.last}
                    onClick={() => onChange(page.number + 1)} >
                    <FaArrowCircleRightIcon />
                </PaginationButton>
            </PaginationBox>
        </Container >
    );

}

export default Pagination;